type LogsConfig = {
    endpoint: string;
    apiKey: string;
    releaseId: string;
    deployEnvironment: string;
};

let logsConfig: LogsConfig | undefined;

export const initLogs = (config: LogsConfig): void => {
    logsConfig = config;
};

export const getLogsConfig = (): LogsConfig | undefined => {
    return logsConfig;
};

export type LogUser = {
    id: number;
    uid: string;
    role: string;
};

export type LogContext = Record<string, unknown>;

export type LogScope = {
    user?: LogUser;
    context: LogContext;
};

const scope: LogScope = { context: {} };

// Replaces the whole user, so fields of a previous user never stay behind.
export const setLogUser = (user: LogUser): void => {
    scope.user = user;
};

// Merges into the current context; a key set to `undefined` is left out of the payload.
export const setLogContext = (context: LogContext): void => {
    scope.context = { ...scope.context, ...context };
};

export const getLogScope = (): Readonly<LogScope> => scope;
